export const types = {
  TOGGLE_DASHBOARD: 'TOGGLE_DASHBOARD',
};
